import { revokedBadgeReasonsClassifierEntityName } from '../../../../backend/config/classifiers/revoked-badge-reasons-classifier/types';
import { classifierGroups } from '../../../../ui/features/badge-admin-pages/classifierGroups';
import { RevokedBadgeReasonsAdminPage } from '../../../../ui/features/badge-admin-pages/components/RevokeBadgeReasonsAdminPage';
import { requireAnySystemPermission } from '@juvare/contact-management/backend/features/permissions/shared';
import { getUserState } from '@juvare/platform-sdk-react/ui/stores';
import { useSelector } from 'react-redux';
export function useRevokedBadgeReasonsClassifierPages() {
    const userState = useSelector(getUserState);
    const pages = [];
    if (userState.badging.badgingEnabled && requireAnySystemPermission(userState, 'manage-revoked-badge-reasons-classifier')) {
        pages.push({
            label: 'Revoked Badge Reasons',
            name: revokedBadgeReasonsClassifierEntityName,
            path: 'revoked-badge-reasons',
            groupLabel: classifierGroups.badges,
            component: RevokedBadgeReasonsAdminPage,
        });
    }
    return pages;
}
